var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSudan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9845 11.3044C0.713095 13.9337 -3.05176e-05 16.8835 -3.05176e-05 20C-3.05176e-05 23.1165 0.713095 26.0662 1.9845 28.6956L20 30.4347L38.0154 28.6956C39.2868 26.0662 40 23.1165 40 20C40 16.8835 39.2868 13.9337 38.0154 11.3044L20 9.56522L1.9845 11.3044Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9852 28.6955C5.22004 35.3854 12.0707 39.9999 20 39.9999C27.9292 39.9999 34.7799 35.3854 38.0147 28.6955H1.9852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9852 11.3043H38.0147C34.7799 4.61442 27.9292 -3.05176e-05 20 -3.05176e-05C12.0707 -3.05176e-05 5.22004 4.61442 1.9852 11.3043Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85782 5.85779C-1.95265 13.6683 -1.95265 26.3316 5.85782 34.1422C9.0854 30.9146 12.1895 27.8104 20 20L5.85782 5.85779Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSudan);
export default __webpack_public_path__ + "static/media/sudan.0c6be0cc83bd69fa8416360d9abdb44f.svg";
export { ForwardRef as ReactComponent };